import SwitcherContainer from "../../../../../src/entities/UI/SwitcherContainer";
import { eventBus, EnumEventBus } from "../managers/EventBus";


const header = "Cat Mode";
const handleFunc = (isActive: boolean) => eventBus.emit(EnumEventBus.catMode, isActive);
const coords = {
  horizontal: { x: 120, y: 320 },
  vertical: { x: -220, y: 630 }
}


export default class CatModeSwitcherCon extends SwitcherContainer {
  constructor() {
    super({ header, coords, handleFunc });
    eventBus.on(EnumEventBus.showSecondAngles, (v: boolean) => this.setActivation(v));
    eventBus.on(EnumEventBus.segmentMode, (v: boolean) => this.setActivation(v));
  }
}